/* eslint-disable */
// Mock temporário do tutorial por tela, usado enquanto o endpoint
// /portal-bi/getTutorial não existe no backend. Quando o endpoint for
// criado, a action `tutorial/buscarTutorial` passa a usar a resposta real
// e este mock só continua servindo de fallback se a API falhar.
//
// Formato do pacote (vindo do GInfo Regras, gerado pelo backend):
// {
//   tipo: "ginfo-regras-pacote",
//   versao, origem, geradoEm, filtro, totais, formatoTexto, tons,
//   itens: [{
//     id, status, criadoEm, atualizadoEm, regiao, regiaoNome, idioma,
//     tela, modulo, caminho, plataforma, resumo,
//     grupos: [{ titulo, cards: [{ numero, titulo, itens: [{
//       rotulo, tom, tipo, texto, topicos: [{ texto, tom, titulo }]
//     }] }] }],
//     prints: []
//   }]
// }
//
// O exemplo abaixo foi fornecido como amostra real desse formato - serve
// só de placeholder visual até o endpoint existir.

const PACOTE_EXEMPLO = {
  tipo: 'ginfo-regras-pacote',
  versao: 1,
  origem: 'GInfo Regras',
  geradoEm: '2026-10-23T19:34:50.100Z',
  filtro: null,
  totais: { regras: 1, cards: 6, prints: 0, pontos: 0 },
  formatoTexto: 'Trechos entre **asteriscos duplos** são negrito. Pontos: x e y em % da largura e altura do print (centro do marcador). "card" é o número do card da regra.',
  tons: {
    ok: 'verde / positivo',
    nok: 'vermelho / negativo',
    warn: 'amarelo / atenção',
    info: 'azul / informativo',
    '': 'neutro'
  },
  itens: [
    {
      id: 'mvldc8483lqkrw',
      status: 'pronto',
      criadoEm: '2026-10-23T19:34:17.624Z',
      atualizadoEm: '2026-10-23T19:34:49.769Z',
      regiao: 'ms',
      regiaoNome: 'Mercosul',
      idioma: 'es',
      tela: 'Adherencia Checklist PY',
      modulo: 'Gestión de flota',
      caminho: 'BI > Flota > Adherencia Checklist PY',
      plataforma: 'BI',
      resumo: 'Mide si cada viaje de los vehículos tuvo su lista de verificación (checklist) realizada en la salida y en el retorno, dentro del horario establecido.',
      grupos: [
        {
          titulo: 'Generación de la adherencia',
          cards: [
            {
              numero: 1,
              titulo: '1. Viajes y checklists esperados',
              itens: [
                {
                  rotulo: 'REGLA',
                  tom: '',
                  tipo: 'text',
                  texto: 'Cada salida de un vehículo de la flota es un **viaje**. Se consideran los vehículos activos de las sucursales del proyecto flota, a partir del 01/01/2024.',
                  topicos: []
                },
                {
                  rotulo: 'CHECKLISTS ESPERADOS',
                  tom: '',
                  tipo: 'text',
                  texto: 'Cada viaje genera dos checklists esperados:',
                  topicos: [
                    { texto: 'Un checklist de **Salida**', tom: '', titulo: false },
                    { texto: 'Un checklist de **Retorno**', tom: '', titulo: false }
                  ]
                },
                {
                  rotulo: 'TOTAL DE VIAJES',
                  tom: '',
                  tipo: 'text',
                  texto: 'Es la suma de todos los **checklists esperados** (salidas + retornos) del período.',
                  topicos: []
                }
              ]
            },
            {
              numero: 2,
              titulo: '2. Vínculo del checklist con el viaje',
              itens: [
                {
                  rotulo: 'SALIDA',
                  tom: '',
                  tipo: 'text',
                  texto: 'Se busca un checklist de salida finalizado, de la misma **placa** y del mismo día de la salida del vehículo.',
                  topicos: []
                },
                {
                  rotulo: 'RETORNO',
                  tom: '',
                  tipo: 'text',
                  texto: 'Se busca un checklist de retorno finalizado, de la misma **placa** y del día del retorno. Si el viaje no tiene fecha de retorno, se usa el día de la salida.',
                  topicos: []
                },
                {
                  rotulo: 'VARIAS SALIDAS EN EL DÍA',
                  tom: '',
                  tipo: 'text',
                  texto: 'Cuando la placa sale más de una vez en el día, los checklists se vinculan por orden: el 1.º checklist del día corresponde al 1.er viaje, el 2.º al 2.º viaje, y así sucesivamente.',
                  topicos: []
                }
              ]
            },
            {
              numero: 3,
              titulo: '3. Resultado y cálculo',
              itens: [
                {
                  rotulo: 'RESULTADO – SALIDA',
                  tom: '',
                  tipo: 'text',
                  texto: 'El resultado de la salida puede ser:',
                  topicos: [
                    { texto: 'OK:', tom: 'ok', titulo: true },
                    { texto: 'Checklist finalizado hasta la hora de salida del vehículo', tom: 'ok', titulo: false },
                    { texto: 'FUERA DE PLAZO:', tom: 'warn', titulo: true },
                    { texto: 'Checklist finalizado después de la hora de salida', tom: 'warn', titulo: false },
                    { texto: 'NOK:', tom: 'nok', titulo: true },
                    { texto: 'Checklist no realizado', tom: 'nok', titulo: false }
                  ]
                },
                {
                  rotulo: 'RESULTADO – RETORNO',
                  tom: '',
                  tipo: 'text',
                  texto: 'El retorno no tiene "Fuera de plazo".',
                  topicos: [
                    { texto: 'OK:', tom: 'ok', titulo: true },
                    { texto: 'Checklist realizado', tom: 'ok', titulo: false },
                    { texto: 'NOK:', tom: 'nok', titulo: true },
                    { texto: 'Checklist no realizado', tom: 'nok', titulo: false }
                  ]
                },
                {
                  rotulo: 'CÁLCULO',
                  tom: '',
                  tipo: 'formula',
                  texto: 'Adherencia % OK = Total OK ÷ Total de viajes\nAdherencia % NOK = Total NOK ÷ Total de viajes\nAdherencia % Fuera de plazo = Total Fuera de plazo ÷ Total de viajes',
                  topicos: []
                }
              ]
            }
          ]
        },
        {
          titulo: 'Plazos e indicadores',
          cards: [
            {
              numero: 4,
              titulo: '4. Cómo funciona el plazo',
              itens: [
                {
                  rotulo: 'HORA LÍMITE',
                  tom: '',
                  tipo: 'text',
                  texto: 'Es la hora de salida del vehículo, considerada hasta el final de ese minuto.',
                  topicos: []
                },
                {
                  rotulo: 'EJEMPLO',
                  tom: '',
                  tipo: 'example',
                  texto: 'Una salida a las 08:15 acepta un checklist finalizado hasta las 08:15:59.',
                  topicos: []
                },
                {
                  rotulo: 'HORA DEL CHECKLIST',
                  tom: '',
                  tipo: 'text',
                  texto: 'Se considera la hora de finalización del checklist, ajustada a la hora local de la sucursal.',
                  topicos: []
                },
                {
                  rotulo: 'RETORNO',
                  tom: '',
                  tipo: 'text',
                  texto: 'El checklist de retorno no tiene hora límite: basta con que sea **realizado**.',
                  topicos: []
                }
              ]
            },
            {
              numero: 5,
              titulo: '5. Tiempo de ejecución',
              itens: [
                {
                  rotulo: 'TIEMPO DEL CHECKLIST',
                  tom: '',
                  tipo: 'text',
                  texto: 'Es el tiempo entre el inicio y la finalización del checklist.',
                  topicos: []
                },
                {
                  rotulo: 'TIEMPO MEDIO',
                  tom: '',
                  tipo: 'text',
                  texto: 'Promedio del tiempo de ejecución de los checklists realizados (hh:mm:ss).',
                  topicos: []
                },
                {
                  rotulo: 'META DE 4 MINUTOS',
                  tom: '',
                  tipo: 'text',
                  texto: 'El porcentaje considera solo los viajes que tuvieron checklist.',
                  topicos: [
                    { texto: '**Por debajo de 4 minutos**: checklist realizado en menos de 4 minutos', tom: '', titulo: false },
                    { texto: '**Por encima de 4 minutos**: checklist realizado en 4 minutos o más', tom: '', titulo: false }
                  ]
                }
              ]
            },
            {
              numero: 6,
              titulo: '6. Otros indicadores',
              itens: [
                {
                  rotulo: 'CHECKLIST CON OS',
                  tom: '',
                  tipo: 'text',
                  texto: 'Porcentaje de checklists realizados (OK o Fuera de plazo) que generaron al menos una **orden de servicio**. Los viajes sin checklist no entran en el cálculo.',
                  topicos: []
                },
                {
                  rotulo: 'ÍTEMS NOK',
                  tom: '',
                  tipo: 'text',
                  texto: 'Cantidad de ítems marcados como no conformes en los checklists (desde 2023), con la situación de la orden de servicio abierta para cada ítem.',
                  topicos: []
                },
                {
                  rotulo: 'PLACAS SIN CHECKLIST',
                  tom: '',
                  tipo: 'text',
                  texto: 'Mes a mes, se verifica cada placa de la flota. Se considera "sin checklist" la placa que no tuvo ningún checklist en el mes, indicando si salió o no en el período.',
                  topicos: []
                },
                {
                  rotulo: 'SALIDAS CON OS CRÍTICA',
                  tom: '',
                  tipo: 'text',
                  texto: 'Cantidad de veces que un vehículo salió con una orden de mantenimiento crítica aún abierta: abierta antes de la salida y no finalizada hasta la hora de salida.',
                  topicos: []
                },
                {
                  rotulo: 'CONDUCTOR Y EQUIPO',
                  tom: '',
                  tipo: 'text',
                  texto: 'El viaje se asigna al conductor registrado en el checklist; si no hay, al conductor informado en el viaje. Si el checklist lo realiza un transportista tercerizado (**freteiro**), el viaje se asigna al equipo de freteiros.',
                  topicos: []
                }
              ]
            }
          ]
        }
      ],
      prints: []
    }
  ]
}

export function getTutorialMock() {
  return PACOTE_EXEMPLO
}
